import { graphql } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import FormError from '../components/FormError/FormError';
import { heroEmailFormSchema } from './validation';
import { StyledFormRow, StyledButton, StyledInput } from './HeroEmailForm.styles';

import useModal from '@/components/Modal/hooks/useModal';
import { store } from '@/utils/storage';
import ModalV2 from '../../ModalV2/ModalV2';

const HeroEmailForm = (props: Queries.HERO_EMAIL_FORMFragment) => {
  const { open } = useModal();
  const { modal, button_text } = props.heroEmailFormElements;
  const { t } = useTranslation();

  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    resolver: zodResolver(heroEmailFormSchema),
    defaultValues: { email: '' },
  });

  const onSubmit = handleSubmit(() => {
    store('USER_EMAIL', emailValue);
    open(modal.value.modalV2Elements.url_slug.value);
  });

  const emailValue = watch('email');

  return (
    <>
      <form onSubmit={onSubmit} data-codename={props.system.codename}>
        <StyledFormRow>
          <StyledInput
            type="email"
            id="email"
            placeholder={t('form.Email')}
            formGroupProps={{ label: '' }}
            {...register('email')}
            errors={errors}
          />
          <StyledButton variant="primary" type="submit" disabled={!!errors?.email}>
            {button_text.value}
          </StyledButton>
        </StyledFormRow>
        {errors?.root?.message && <FormError>{errors.root.message}</FormError>}
      </form>
      <ModalV2 {...modal.value} />
    </>
  );
};

export const fragment = graphql`
  fragment HERO_EMAIL_FORM on kontent_item_hero_email_form {
    __typename
    heroEmailFormElements: elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      button_text {
        value
      }
      modal {
        value {
          ...MODAL_V2
        }
      }
    }
    system {
      id
      codename
    }
  }
`;

export default HeroEmailForm;
